import defaultConfig from './default';
import stagingConfig from './staging';
import prodConfig from './production';

// INFO: why retarded imports instead of dynamic imports?
// Cos' IE11 DOES NOT support dynamic imports and breaks the JS bundle
interface IConfig {
  API_URL: string;
  API_APP_ID: string;
  GA_TRACKING_ID: string;
  FRONT_END_URL: string;
}

const configurations = {
  development: defaultConfig,
  staging: stagingConfig,
  production: prodConfig
};

const env = process.env.NODE_ENV || 'development';

export const Config: IConfig = configurations[env];



// WEBPACK FOOTER //
// ./src/config/index.ts